import { apiClient, apiDownload } from "./apiClient";

export type SalesVendor = "applixure" | "cuuma";
export type BillingConfig = { customerId: string; customerName: string; contractId: string; productCode: string; markupPercent: string };
export type SalesSettings = { vendor: SalesVendor; version: string; config: BillingConfig; documentation: string; updatedAt: string | null; updatedBy: string | null };
export type SalesRow = {
  customerId: string; customerName: string; contractId: string; productCode: string; description: string;
  startDate: string; endDate: string; netPrice: string; quantity: number; workBillingCode: string;
  category: "license" | "system" | "traffic"; sourceNet: string;
  source: { file: string; page?: number; customer?: string; pcCount?: number; customerReference?: string };
};
export type SalesAnalysis = {
  id: string; vendor: SalesVendor; rows: SalesRow[]; config: BillingConfig; rowCount: number;
  sourceTotal: string; netTotal: string;
  metadata: { startDate: string; endDate: string; files: string[]; pcCount?: number; invoiceNumber?: string; systemTotal?: string; trafficTotal?: string; systemRows?: number; trafficRows?: number; totalsVerified: boolean };
  exportSignature: string; exportExpiresAt: number; exportUser: string;
};

export const salesInvoiceDataApi = {
  settings: (vendor: SalesVendor) => apiClient<SalesSettings>(`/purchase-invoices/sales/${vendor}/settings`),
  update: (vendor: SalesVendor, payload: { version: string; config?: BillingConfig; documentation?: string }) =>
    apiClient<SalesSettings>(`/purchase-invoices/sales/${vendor}/settings`, { method: "PATCH", body: JSON.stringify(payload) }),
  analyze: (vendor: SalesVendor, files: Record<string, File>) => {
    const body = new FormData();
    Object.entries(files).forEach(([key, file]) => body.append(key, file));
    return apiClient<SalesAnalysis>(`/purchase-invoices/sales/${vendor}/analyze`, { method: "POST", body });
  },
  export: (analysis: SalesAnalysis) => apiDownload(`/purchase-invoices/sales/${analysis.vendor}/export`, { method: "POST", body: JSON.stringify(analysis) })
};
